import { ChainId } from '@ui/types/chain';
import { getContract, PublicClient, WalletClient } from 'viem';

import PairsManagerFacet from '../abis/PairsManagerFacet';
import { getContractAddress } from '../constants/address';

export const getPairsManagerFacet = ({
  publicClient,
  walletClient,
  chainId,
}: {
  publicClient: PublicClient;
  walletClient?: WalletClient;
  chainId: ChainId;
}) => {
  const address = getContractAddress('LeverUp', chainId);
  if (!address) throw new Error('Contract address not found');

  return getContract({
    abi: PairsManagerFacet,
    address,
    client: {
      public: publicClient,
      wallet: walletClient,
    },
  });
};
